<template>
  <a-date-picker style="width: 100%;" v-model="value" show-time allowClear @change="change"></a-range-picker>
  </a-date-picker>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    time: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      value: this.time
    }
  },
  methods: {
    change (e) {
      console.log(e)
      if (e) {
        this.$emit('update:time', moment(e).format('YYYY-MM-DD HH:mm:ss'))
      } else {
        this.$emit('update:time', undefined)
      }
    }
  }
}
</script>
<style lang="less" scoped>

</style>
